import FormGroup from "features/shared/forms/components/FormGroup";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  bindField: any;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  errors: Record<string, string>;
  editable: boolean;
}

const AnnualCapacity = ({ bindField, onBlur, errors, editable }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  if (editable) {
    return (
      <FormGroup
        labelText={tLabels("annualCapacity.requiredAnnualCapacity")}
        validationError={errors ? errors["DESC_TMZMSMLEEKAPROCNI"] : undefined}
      >
        <div className="input-group">
          <input
            className="form-control"
            placeholder={tLabels("annualCapacity.setAnnualCapacity")}
            onBlur={onBlur}
            {...bindField("DESC_TMZMSMLEEKAPROCNI")}
          />
          <div className="input-group-append">
            <span className="input-group-text">MW</span>
          </div>
        </div>
      </FormGroup>
    );
  } else {
    return null;
  }
};

export default AnnualCapacity;
